"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUltraSwapMutation = void 0;
const wallet_adapter_1 = require("@jup-ag/wallet-adapter");
const react_query_1 = require("@tanstack/react-query");
const UltraSwapService_1 = require("src/data/UltraSwapService");
const buffer_1 = require("buffer");
const web3_js_1 = require("@solana/web3.js");
const WalletPassthroughProvider_1 = require("src/contexts/WalletPassthroughProvider");
const TransactionError_1 = require("src/entity/TransactionError");
var UltraSwapErrorType;
(function (UltraSwapErrorType) {
    UltraSwapErrorType["REJECTED"] = "REJECTED";
    UltraSwapErrorType["FAILED"] = "FAILED";
    UltraSwapErrorType["WALLET_SIGNING_FAILED"] = "WALLET_SIGNING_FAILED";
})(UltraSwapErrorType || (UltraSwapErrorType = {}));
class UltraSwapError extends Error {
    constructor(message, type, txid) {
        super(message);
        this.type = type;
        this.txid = txid;
    }
}
function useUltraSwapMutation() {
    const { wallet, signTransaction } = (0, WalletPassthroughProvider_1.useWalletPassThrough)();
    return (0, react_query_1.useMutation)({
        mutationFn: ({ setTxStatus, setLastSwapResult, fromTokenInfo, toTokenInfo, quoteResponseMeta, }) => __awaiter(this, void 0, void 0, function* () {
            const publicKey = wallet === null || wallet === void 0 ? void 0 : wallet.adapter.publicKey;
            if (!signTransaction || !publicKey) {
                throw new UltraSwapError('Wallet not connected, or missing wallet functions', UltraSwapErrorType.WALLET_SIGNING_FAILED);
            }
            setTxStatus({
                txid: '',
                status: 'pending-approval',
            });
            const selectedQuote = quoteResponseMeta.original;
            const { transaction, requestId } = selectedQuote;
            if (!transaction)
                throw new Error('Missing transaction');
            const based64tx = buffer_1.Buffer.from(transaction, 'base64');
            const versionedTransaction = web3_js_1.VersionedTransaction.deserialize(new Uint8Array(based64tx));
            const signedTransaction = yield signTransaction(versionedTransaction);
            const serializedTransaction = buffer_1.Buffer.from(signedTransaction.serialize()).toString('base64');
            setTxStatus({
                txid: '',
                status: 'sending',
            });
            const response = yield UltraSwapService_1.ultraSwapService.submitSwap(serializedTransaction, requestId);
            const { signature, status } = response;
            if (status === 'Failed') {
                throw new UltraSwapError(response.error, UltraSwapErrorType.FAILED, signature);
            }
            const { inputAmountResult, outputAmountResult } = response;
            setTxStatus({
                txid: signature,
                status: 'success',
            });
            setLastSwapResult({
                swapResult: {
                    txid: signature,
                    inputAddress: new web3_js_1.PublicKey(fromTokenInfo.id),
                    outputAddress: new web3_js_1.PublicKey(toTokenInfo.id),
                    inputAmount: Number(inputAmountResult),
                    outputAmount: Number(outputAmountResult),
                },
                quoteReponse: quoteResponseMeta,
            });
            return signature;
        }),
        onError: (error, variables) => __awaiter(this, void 0, void 0, function* () {
            const { setTxStatus, setLastSwapResult, quoteResponseMeta } = variables;
            if (error instanceof wallet_adapter_1.WalletSignTransactionError) {
                const message = error.message || error.error || 'Transaction cancelled';
                setLastSwapResult({
                    swapResult: {
                        error: new TransactionError_1.TransactionError(message),
                    },
                    quoteReponse: quoteResponseMeta,
                });
                return;
            }
            if (error instanceof Error) {
                setLastSwapResult({
                    swapResult: {
                        error: new TransactionError_1.TransactionError(error.message),
                    },
                    quoteReponse: quoteResponseMeta,
                });
                return;
            }
            if ('json' in error) {
                const json = (yield error.json());
                setLastSwapResult({
                    swapResult: {
                        error: new TransactionError_1.TransactionError(json.error || 'Unknown error'),
                    },
                    quoteReponse: quoteResponseMeta,
                });
                setTxStatus({
                    txid: json.txid || '',
                    status: 'fail',
                });
            }
        }),
    });
}
exports.useUltraSwapMutation = useUltraSwapMutation;
